export default "__VITE_ASSET__BZo2vttR__"